const SET_COMMENCED = '[schedule]set.commenced';
const SET_COMPLETED = '[schedule]set.completed';
const SET_CANT_START_MESSAGE = '[schedule]set.cant.start.msg';

export {SET_COMPLETED, SET_COMMENCED, SET_CANT_START_MESSAGE}